import React from "react";
import Pricing from "../Pricing";

export default function PricingSection({ data }) {
    const { tituloSeccion, subtituloSeccion, productos, textoBoton, textoMoneda, tituloCaracteristicas, notaFinal, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'pricing';

    return (
        <Pricing
            titulo={tituloSeccion}
            subtitulo={subtituloSeccion}
            productos={productos}
            textoBoton={textoBoton}
            textoMoneda={textoMoneda}
            tituloCaracteristicas={tituloCaracteristicas}
            notaFinal={notaFinal}
            id={ancla}
        />
    );
}
